import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons.js'
import ClassNames from './embla-carousel-class-names.esm.js'
import AutoScroll from './embla-carousel-auto-scroll.esm.js'

(function () {

  
  const OPTIONS = { 
    loop: true,
  }
  
  function waitForEmbla(method) {
    if (typeof EmblaCarousel != 'undefined') {
        method();
    } else {
        setTimeout(function() { waitForEmbla(method) }, 50);
    }
  }
  
  // function waitForAuto(method) {
  //   if (typeof AutoScroll != 'undefined') {
  //       method();
  //   } else {
  //       setTimeout(function() { waitForAuto(method) }, 50);
  //   }
  // }
  
  waitForEmbla(init);
  
  function init() {
    const carousels = document.querySelectorAll('.embla:not(.mounted)');
  
    Array.from(carousels).map(function(emblaNode) {
      
      const plugins = [ClassNames()]
    
      const viewportNode = emblaNode.querySelector('.embla__viewport')
  
      if(emblaNode.classList.contains('auto')) plugins.push(AutoScroll({
        interval: 3000,  // Set the interval for autoscroll in milliseconds
        speed: 1,
        stopOnInteraction: false, // Continue scrolling even if user interacts
        stopOnMouseEnter: false,  // Don't stop when mouse enters
        playOnInit: true,  // Autoscroll starts immediately on init
      }));
  
      mountEmbla(emblaNode, viewportNode, OPTIONS, plugins) 
  
    });
    
  }
  
  function mountEmbla(emblaNode, viewportNode, OPTIONS, plugins) {
    console.log(OPTIONS)
    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, plugins);
    emblaNode.classList.add('mounted');
  
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
    const nextBtnNode = emblaNode.querySelector('.embla__button--next')
  
    if(prevBtnNode && nextBtnNode) {
  
      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode
      )
      
      emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
      
      if(emblaNode.classList.contains('video-carousel')) {
          emblaApi.scrollNext();
          emblaApi.on('select', function() {
             const slides = emblaNode.querySelectorAll('.embla__slide');

             Array.from(slides).map((slide) => {
                const vid = slide.querySelector('video');
                const playBtn = slide.querySelector('.play-btn');

                if(vid) {
                  vid.pause();
                  playBtn.classList.remove('playing');
                }
             });

          });
      }

      
    }
    
   
  }
  
}());

